export default __webpack_public_path__ + "static/media/affiliate-resource-background.fdc05651.png";